import { MarketCode } from '../@types/MarketCode';

export const getMarketCode = () =>
  (document.documentElement.getAttribute('data-market-code')?.toUpperCase() as MarketCode) || 'SE';
